import { backendURL } from 'services/backendAPI';

export const getLisaSlideLink = ({ slide }) => `${backendURL}/lisa/core/slide/${slide.id}/change/`;

export const getLISAOrderLinkFromSlide = ({ slide }) => {
  if (!slide.order.id) {
    return '';
  }
  
  return `${backendURL}/lisa/core/order/${slide.order.id}/change/`;
};

export const getLisaIFSlideLink = (ifSlide) => `${backendURL}/lisa/core/slide/${ifSlide?.id}/change/`;

export const getLISSlideAntibodyLink = (slide) => {
  const antibodyId = slide.antibody?.id;

  if (!antibodyId) {
    return '';
  }

  const antibodyLink = `${backendURL}/lisa/core/antibody/${antibodyId}/change/#slides-group`;
  
  return antibodyLink;
};
